import { useRef, type CSSProperties } from 'react';
import {
  buildColumnHighlightStyle,
  SCHEDULE_SLOT_HIGHLIGHT_COLOR,
  type SlotBandPx,
} from './scheduleGridPlacementHighlight';

type CourtPlacementHighlightProps = {
  bandsPx: SlotBandPx[];
  contentHeightPx: number;
  headerHeight: number;
};

export function CourtPlacementHighlight({
  bandsPx,
  contentHeightPx,
  headerHeight,
}: CourtPlacementHighlightProps) {
  const styleCacheRef = useRef<{ bands: SlotBandPx[]; highlightStyle?: CSSProperties } | null>(
    null
  );

  if (bandsPx.length === 0) return null;

  const prev = styleCacheRef.current;
  const bandsUnchanged =
    prev &&
    prev.bands.length === bandsPx.length &&
    prev.bands.every((b, i) => b.top === bandsPx[i].top && b.bottom === bandsPx[i].bottom);
  const highlightStyle = bandsUnchanged
    ? prev!.highlightStyle
    : buildColumnHighlightStyle(bandsPx, contentHeightPx, SCHEDULE_SLOT_HIGHLIGHT_COLOR);
  styleCacheRef.current = { bands: bandsPx, highlightStyle };

  return (
    <div
      className="court-slot-highlight"
      aria-hidden
      style={{
        top: headerHeight,
        height: contentHeightPx,
        width: '100%',
        ...highlightStyle,
      }}
    />
  );
}
